module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.field.type !== 'checkbox') ? _c('div', {
    class: "document-field document-field--" + (_vm.field.type) + " " + _vm.isForCurrentParty + _vm.isMergeField,
    style: (("width: " + (_vm.field.width) + "%; height: " + (_vm.field.height) + "%; top: " + (_vm.field.y) + "%; left: " + (_vm.field.x) + "%;color: " + (_vm.field.color))),
    attrs: {
      "data-id": _vm.field.id,
      "data-page": _vm.pageIndex,
      "data-input": _vm.fieldIndex
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.openFieldPopup($event)
      }
    }
  }, [(_vm.field.required == 'true' && !_vm.isMergeField && !_vm.isDisabled) ? _c('div', {
    staticClass: "document-field__label"
  }, [_c('icon', {
    attrs: {
      "name": "asterisk",
      "height": "10",
      "width": "10"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.field.type == 'signature') ? [(_vm.isSignatureImage) ? [(_vm.isURL) ? _c('img', {
    attrs: {
      "src": ("https://docs-cdn.signable.co.uk/signatures/" + _vm.signature)
    }
  }) : (_vm.isBase64) ? _c('img', {
    attrs: {
      "src": _vm.signature
    }
  }) : _vm._e()] : (_vm.signature != null && _vm.signature != '') ? [_c('span', [_vm._v(_vm._s(_vm.signature))])] : (_vm.isForCurrentParty && !_vm.isDisabled) ? [_c('span', {
    staticClass: "no-font"
  }, [_vm._v(_vm._s(_vm.$t('documentField.clickToAddSignature')))])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.field.type == 'text') ? [_c('fit-text', {
    attrs: {
      "changed": _vm.changedFontSize
    }
  }, [_vm._v(_vm._s(_vm.fieldText))])] : _vm._e(), _vm._v(" "), (_vm.field.type == 'textarea') ? [_c('span', [_vm._v(_vm._s(_vm.fieldText))])] : _vm._e(), _vm._v(" "), (_vm.field.type == 'date') ? [_c('fit-text', {
    attrs: {
      "changed": _vm.changedFontSize
    }
  }, [_vm._v(_vm._s(_vm.fieldText))])] : _vm._e(), _vm._v(" "), (_vm.field.type == 'upload') ? [(!_vm.isDisabled) ? _c('span', [_vm._v(_vm._s(_vm.field.upload === null ? _vm.$t('documentField.uploadYourFiles') : _vm.$t('documentField.filesHaveBeenUploaded')))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.field.type == 'dropdown') ? [_c('fit-text', {
    attrs: {
      "changed": _vm.changedFontSize
    }
  }, [_vm._v(_vm._s(_vm.fieldText))]), _vm._v(" "), _c('icon', {
    staticClass: "dropdown-icon",
    attrs: {
      "name": "caret-down",
      "height": "12",
      "widt": "12"
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.isDisabled) ? _c('field-popup', {
    attrs: {
      "type": _vm.field.type,
      "id": _vm.field.id,
      "field": _vm.field,
      "title": _vm.field.title,
      "required": _vm.field.required,
      "closeFieldPopup": _vm.closeFieldPopup,
      "updateFieldText": _vm.updateFieldText,
      "selectDropdownChoice": _vm.selectDropdownChoice,
      "isActive": _vm.activePopupId == _vm.field.id
    }
  }) : _vm._e()], 2) : _c('div', {
    class: "document-field document-field--" + (_vm.field.type) + (_vm.highlight ? ' document-field--highlighted' : '') + _vm.isForCurrentParty,
    style: (("width: " + (_vm.field.width) + "%; height: " + (_vm.field.height) + "%; top: " + (_vm.field.y) + "%; left: " + (_vm.field.x) + "%;")),
    attrs: {
      "data-id": _vm.field.id,
      "data-page": _vm.pageIndex,
      "data-input": _vm.fieldIndex
    }
  }, [(_vm.field.required === 'true' && !_vm.isMergeField && !_vm.isDisabled) ? _c('div', {
    staticClass: "document-field__label document-field__label--checkbox"
  }, [_c('icon', {
    attrs: {
      "name": "asterisk",
      "height": "6",
      "width": "6"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": _vm.field.type,
      "name": _vm.field.group,
      "id": _vm.field.id,
      "is-disabled": _vm.isDisabled,
      "onSelect": _vm.selectCheckbox
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f92784aa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentField.vue
// module id = 1066
// module chunks = 1